'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNewStore = createNewStore;

var _redux = require('redux');

var _reduxUniversal = require('@bd/redux-universal');

var _reduxUniversal2 = _interopRequireDefault(_reduxUniversal);

var _reactRouterRedux = require('react-router-redux');

var _createBrowserHistory = require('history/createBrowserHistory');

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createMemoryHistory = require('history/createMemoryHistory');

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Grab the state from a global variable injected into the server-generated HTML
var preloadedState = void 0;
var historyCreator = _createMemoryHistory2.default;
var applyMiddleware = _reduxUniversal2.default;

if (typeof global.window !== 'undefined' && !process.env.REACT_APP_SERVER) {
  applyMiddleware = _redux.applyMiddleware;

  // Grab the state from a global variable injected into the server-generated HTML
  preloadedState = global.window.__PRELOADED_STATE__;

  // Allow the passed state to be garbage-collected
  delete global.window.__PRELOADED_STATE__;

  historyCreator = _createBrowserHistory2.default;
}

function createNewStore() {
  var enhancer = void 0;

  var history = historyCreator();

  if (process.env.NODE_ENV !== 'production') {
    enhancer = (0, _redux.compose)(applyMiddleware(_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(history)));
  } else {
    history.listen(function (location) {
      if (typeof window.ga === 'function') {
        window.ga('set', 'page', location.pathname + location.search);
        window.ga('send', 'pageview', location.pathname + location.search);
      }

      if (window.LassoCRM && window.LassoCRM.tracker) {
        window.LassoCRM.tracker.track();
      }
    });

    enhancer = (0, _redux.compose)(applyMiddleware(_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(history)));
  }

  var store = (0, _redux.createStore)(_reducers2.default, preloadedState, enhancer);

  return { store: store, history: history };
}

exports.default = createNewStore();


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/configureStore.js
// module id = 890
// module chunks = 0